import { forwardRef } from "react";

import { omit } from "lodash";
import { useUniqueId } from "../Utils/uniqueId";

const DivSlide = (props, ref) => {
  // Passthrough props include Nuka-carousel provided accessibility related props like
  // aria-hidden and tabIndex props.
  const passthroughProps = omit(props, "slide");
  const id = useUniqueId("carousel-slide");

  return (
    <div id={id} className="slide-container" ref={ref} {...passthroughProps}>
      {props.children}
    </div>
  );
};

export default forwardRef(DivSlide);
